<template>
  <div :content="specs.title"
       v-tippy="{ placement : 'top',  arrow: true, theme: 'light' }"
       class="absolute z-10 flex items-center justify-center w-10 h-10 text-white rounded-full cursor-pointer t3m-ImageMap-hotspot top-full hover:bg-primary-hover bg-primary"
       :style="style"
       @click="selectHotspot(specs)">
       <span class="absolute inset-0 duration-1000 rounded-full bg-primary animate-ping-slow"></span>
    <svg xmlns="http://www.w3.org/2000/svg"
         class="relative w-4 h-4"
         viewBox="0 0 448 512"
         fill="currentColor">
      <path
            d="M432 256C432 269.3 421.3 280 408 280h-160v160c0 13.25-10.75 24.01-24 24.01S200 453.3 200 440v-160h-160c-13.25 0-24-10.74-24-23.99C16 242.8 26.75 232 40 232h160v-160c0-13.25 10.75-23.99 24-23.99S248 58.75 248 72v160h160C421.3 232 432 242.8 432 256z">
      </path>
    </svg>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "t3mHotspot",
  props: {
    specs: Object
  },
  computed: {
    style: function () {
      return `left: ${this.specs.x}%; top: ${this.specs.y}%;`;
    }
  },
  methods: {
    ...mapActions(["selectHotspot"])
  }
};
</script>
